[
  {
    "locale": "fr-FR",
    "space": "16pxxgwwc02e",
    "accessToken": "DALAZchQ0oRwvFumWQacga0wt3zoYXqIt4L45uIQoI4"
  }
]